<template>
  <Button 
    :class="[
      'relative overflow-hidden group transition-all duration-300',
      buttonClass,
      variant === 'primary' ? 'bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary' : '',
      variant === 'secondary' ? 'border-primary/20 hover:border-primary hover:bg-primary/5' : '',
      effects.includes('scale') ? 'hover:scale-105' : '',
      effects.includes('shadow') ? 'hover:shadow-lg' : '',
      effects.includes('glow') ? 'hover:shadow-primary/25' : ''
    ]"
    v-bind="$attrs"
  >
    <span class="relative z-10 flex items-center gap-2">
      <slot name="icon" />
      <slot />
      <component 
        v-if="showArrow" 
        :is="ArrowRight" 
        class="size-5 ml-2 group-hover:translate-x-1 transition-transform relative z-10" 
      />
    </span>
    
    <!-- 按钮光效 -->
    <div 
      v-if="effects.includes('shine')"
      class="absolute inset-0 bg-gradient-to-r from-white/10 via-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
    ></div>
    
    <!-- 扫光效果 -->
    <div 
      v-if="effects.includes('sweep')"
      class="absolute inset-0 -inset-x-4 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500 transform -skew-x-12 group-hover:translate-x-full"
    ></div>
    
    <!-- 渐变背景悬停效果 -->
    <div 
      v-if="effects.includes('gradient')"
      class="absolute inset-0 bg-gradient-to-r from-primary/10 to-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-md"
    ></div>
  </Button>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-vue-next';

interface Props {
  variant?: 'primary' | 'secondary' | 'outline';
  showArrow?: boolean;
  effects?: string[];
  buttonClass?: string;
}

withDefaults(defineProps<Props>(), {
  variant: 'primary',
  showArrow: false,
  effects: () => ['scale', 'shadow'],
  buttonClass: ''
});
</script>
